export const HOST = import.meta.env.VITE_HOST_API;
export const VERSION = 'api/v1/';

const APP_URL = {
    GUARDARFORMWEB: `${HOST}${VERSION}app/request/sendInfoOlan`,
    GUARDARCRMFORMWEB: `${HOST}${VERSION}web/contrato/crearLeadInstitucion`,
}

export default APP_URL
